var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdditionalInfoAssignmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16797 3.44332C1.16797 2.60577 1.84893 1.9248 2.68649 1.9248H6.48278V4.96184C6.48278 5.38181 6.82208 5.7211 7.24204 5.7211H10.2791V8.70357L8.21959 10.7631C7.9752 11.0074 7.80437 11.3111 7.72133 11.6457L7.27763 13.4228C7.22306 13.6411 7.23492 13.8689 7.30848 14.0753H2.68649C1.84893 14.0753 1.16797 13.3944 1.16797 12.5568V3.44332ZM10.2791 4.96184H7.24204V1.9248L10.2791 4.96184ZM14.213 7.51722L14.5547 7.85889C14.9248 8.22903 14.9248 8.82932 14.5547 9.20183L13.8571 9.8994L12.1725 8.21479L12.8701 7.51722C13.2402 7.14708 13.8405 7.14708 14.213 7.51722ZM8.56837 11.8189L11.6339 8.75339L13.3185 10.438L10.253 13.5011C10.1557 13.5984 10.0347 13.6672 9.89945 13.7004L8.47347 14.0563C8.34297 14.0896 8.20773 14.0516 8.11282 13.9567C8.01791 13.8618 7.97995 13.7265 8.01316 13.596L8.36907 12.1701C8.40229 12.0372 8.47109 11.9138 8.56837 11.8165V11.8189Z",
    fill: "#343435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalInfoAssignmentIcon);
export default __webpack_public_path__ + "static/media/AdditionalInfoAssignmentIcon.2843d627202082168f006059b976d448.svg";
export { ForwardRef as ReactComponent };